var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuilarHappy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 86.84,
    viewBox: "0 0 69 86.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2",
    transform: "translate(-1 -10.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1",
    "data-name": "Trazado 1",
    d: "M70,38.647V62.63a34.5,34.5,0,0,1-69,0V38.647H21.47V62.63a14.03,14.03,0,1,0,28.06,0V38.647Z",
    fill: "#171c8f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2",
    "data-name": "Rect\\xE1ngulo 2",
    width: 20.5,
    height: 20.5,
    rx: 10,
    transform: "translate(1 10.29)",
    fill: "#ee5340"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3",
    "data-name": "Rect\\xE1ngulo 3",
    width: 20.5,
    height: 20.5,
    rx: 10,
    transform: "translate(49.5 10.29)",
    fill: "#ee5340"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilarHappy);
export default __webpack_public_path__ + "static/media/builar-happy.d9f00ca71c35d51744a5092c2e0d0ee4.svg";
export { ForwardRef as ReactComponent };